import { render, staticRenderFns } from "./stat_list.vue?vue&type=template&id=45a2e389&scoped=true&"
import script from "./stat_list.vue?vue&type=script&lang=js&"
export * from "./stat_list.vue?vue&type=script&lang=js&"
import style0 from "./stat_list.vue?vue&type=style&index=0&id=45a2e389&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/registry.npmjs.org/vue-loader/15.8.3_25647bdc581bdda9c9b762adc3f55a51/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a2e389",
  null
  
)

export default component.exports